import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="px-4 md:px-8 py-24 md:py-40 bg-background-50 min-h-[60vh] flex items-center justify-center">
      <div className="max-w-xl text-center">
        <div className="inline-flex items-center gap-2 mb-4 px-3 py-1 rounded-full bg-background-100 border border-background-200 text-[11px] uppercase tracking-[0.18em] text-foreground-700">
          <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
          404 — wrong wire
        </div>
        <h1 className="text-4xl md:text-6xl font-heading font-semibold tracking-tight text-foreground-950 leading-tight">
          That page has gone off the grid.
        </h1>
        <p className="mt-4 text-foreground-600">
          Let's get you back somewhere useful.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-5 py-3.5 rounded-full bg-primary-950 text-background-50 text-sm font-semibold hover:bg-primary-900 transition-colors cursor-pointer whitespace-nowrap"
          >
            Back home
            <i className="ri-arrow-right-line"></i>
          </Link>
          <Link
            to="/book"
            className="inline-flex items-center gap-2 px-5 py-3.5 rounded-full border border-background-300 text-foreground-800 text-sm font-semibold hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
          >
            Book Appointment
            <i className="ri-arrow-right-up-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}